import React, { useState, useEffect } from "react";
import Switch from '@mui/material/Switch';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import "../../../styles/Auth/subCategory.css";
import FullscreenLoader from "../../../components/Common/FullscreenLoader.jsx";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import Select from "react-select";
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import { postData, uploadFile, getData, putData, deleteData } from "../../../webService/webservice";
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import ViewsubCategoryPopup from './subCategoryPopup.jsx';
import { toast } from "react-toastify";
const SubCategoryPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAddPage = location.pathname === '/sub-category/add';
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        display: "flex",
        alignItems: 'center',
        justifyContent: "left"
    };
    const headings = [
        'SL',
        'Image',
        'SubCategory',
        'Category',
        'Code',
        'Status',
        'Online',
        'Action',
    ];
    const [subcategoryImage, setsubCategoryImage] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const [loading, setLoading] = useState(false);
    const [stores, setStores] = useState([]);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [categories, setCategories] = useState([]);
    const [subcategories, setsubcategories] = useState([]);
    const [viewsubCategoryData, setViewsubCategoryData] = useState(null);
    const [limit, setLimit] = useState(5);
    const [searchQuery, setSearchQuery] = useState('');
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const sessionToken = sessionStorage.getItem("sessionToken");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editsubCategoryId, setEditsubCategoryId] = useState(null);
    const [subcategoryToDelete, setsubCategoryToDelete] = useState(null);
    const [attributes, setAttributes] = useState('');
    const [formData, setFormData] = useState({
        categoryId: '',
        subCategoryName: '',
        description: '',
        subCategoryImageObject: '',
        subCategoryCode: '',
        attributes: [],
    });

    const [errors, setErrors] = useState({});
    const handleAddSubCategory = async (e) => {
        e.preventDefault();
        
        let newErrors = {};

        if (!formData.categoryId.trim()) {
            newErrors.categoryId = "Category Name is required.";
        }

        if (!formData.subCategoryName.trim()) {
            newErrors.subCategoryName = "Subcategory Name is required.";
        }

        if (!formData.attributes || formData.attributes.length === 0) {
            newErrors.attributes = "Please select at least one attribute.";
        }

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;
        setLoading(true);
        
        try {
            const token = sessionStorage.getItem("sessionToken");
            const userId = sessionStorage.getItem("userId");
            let uploadResult;
            if (subcategoryImage) {
                uploadResult = await uploadFile(`files/upload/${userId}`, subcategoryImage);
                if (uploadResult?.status === 200) {
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                }
            } 
           
            // Build the full image URL
            const subCategoryData = {
                categoryId: formData.categoryId,
                subCategoryName: formData.subCategoryName,
                description: formData.description,
                subCategoryImageObject: uploadResult?.data,
                subCategoryCode: formData.subCategoryCode,
                attributes: formData.attributes || []
            };
            console.log("Sending  subcategory data:", subCategoryData);

            const response = await postData('subcategories/', subCategoryData, token);

            toast.success(response.message || 'Sub Category added successfully');
            setFormData({ subCategoryName: '', description: '', subCategoryImageObject: '', subCategoryCode: '' });
            setsubCategoryImage(null);
            setPreviewUrl(null);
            navigate("/sub-category");
            triggerRefresh();
        } catch (error) {
            console.error('Add subCategory Error:', error);
            toast.error(error.message || 'Add subCategory Failed');
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        const fetchSubCategories = async () => {
            try {
                setLoading(true);
                const params = {
                    page: currentPage,
                    limit,
                    subCategoryName: searchQuery?.trim() || "",
                };
                const data = await getData('subcategories/subcategories', params, sessionToken);
                const results = data?.data?.results?.[0]?.paginatedResults || [];
                setsubcategories(results);
                setTotalPages(data?.data?.results?.[0]?.totalPages || 1);
                setTotalCount(data?.data?.results?.[0]?.totalCount || 0);
            } catch (error) {
                toast.error(error.message || "Failed to fetch subcategories");
            } finally {
                setLoading(false);
            }
        };
        fetchSubCategories();
    }, [currentPage, limit, refreshKey, searchQuery]);

    const handleUpdateSubCategory = async (e) => {
        e.preventDefault();
        let newErrors = {};

        if (!formData.categoryId.trim()) {
            newErrors.categoryId = "Category Name is required.";
        }

        if (!formData.subCategoryName.trim()) {
            newErrors.subCategoryName = "Subcategory Name is required.";
        }

        if (!formData.attributes || formData.attributes.length === 0) {
            newErrors.attributes = "Please select at least one attribute.";
        }
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;
        setLoading(true);
        try {
            const token = sessionStorage.getItem("sessionToken");
            const userId = sessionStorage.getItem("userId");

            let updatedImageObject = formData.subCategoryImageObject;

            if (subcategoryImage && userId) {
                const uploadResult = await uploadFile(`files/upload/${userId}`, subcategoryImage);

                if (uploadResult?.status === 200 || uploadResult?.success) {
                    updatedImageObject = uploadResult.data;
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                    return;
                }
            }


            const updatedSubCategoryData = {
                categoryId: formData.categoryId,
                subCategoryName: formData.subCategoryName,
                description: formData.description,
                subCategoryImageObject: updatedImageObject,
                subCategoryCode: formData.subCategoryCode,
                attributes: formData.attributes || []
            };

            console.log("Updating category with data:", updatedSubCategoryData);

            const response = await putData(`subcategories/subcategory/${editsubCategoryId}`, updatedSubCategoryData, token);

            toast.success(response.message || 'Category updated successfully');

            // Step 4: Reset form and close modal
            setFormData({ categoryId: '', subCategoryName: '', description: '', subCategoryImageObject: null, subCategoryCode: '' });
            setsubCategoryImage(null);
            setPreviewUrl(null);
            setIsPopupMode(false);
            setIsEditMode(false);
            triggerRefresh();
        } catch (error) {
            toast.error("Error updating category.");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteCategory = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const token = sessionStorage.getItem('sessionToken');
            const response = await deleteData(`subcategories/subcategory/${subcategoryToDelete}`, token);
            toast.success(response.message || "subCategory deleted successfully");
            setsubCategoryToDelete(null);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete subCategory");
        } finally {
            setLoading(false);
        }
    };

    const handleViewsubCategory = async (subCategoryId) => {
        try {
            setLoading(true);
            const sessionToken = sessionStorage.getItem("sessionToken");
            if (!sessionToken) {
                toast.error("Session expired. Please log in again.");
                return;
            }

            const response = await getData(`subcategories/subcategory/${subCategoryId}`, sessionToken);

            // Depending on your webservice, check if data is nested
            const data = response?.data || response;

            if (!data) {
                toast.error("No data found for this subcategory.");
                return;
            }

            setViewsubCategoryData(data);
            setOpenViewPopup(true);
        } catch (error) {
            console.error("Error fetching subcategory:", error);
            toast.error(error.message || "Failed to fetch subcategory data");
        } finally {
            setLoading(false);
        }
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleOpen = (subCategoryId) => {
        setsubCategoryToDelete(subCategoryId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setsubCategoryToDelete(null);
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const handleToggle = async (subCategoryId, newStatus) => {
        try {
            setLoading(true);
            const token = sessionStorage.getItem("sessionToken");

            const response = await putData(
                `subcategories/toggle-status/${subCategoryId}`,
                { isActive: newStatus },    // send true or false
                token
            );

            toast.success(response.message || "Status updated!");

            triggerRefresh();
        } catch (error) {
            console.error("Toggle Error:", error);
            toast.error("Failed to update status");
        } finally {
            setLoading(false);
        }
    };

    const handleToggleOnline = async (subCategoryId, newStatus) => {
        try {
            setLoading(true);
            const token = sessionStorage.getItem("sessionToken");

            const response = await putData(
                `subcategories/toggle-online-status/${subCategoryId}`,
                { isOnline: newStatus },    // send true or false
                token
            );

            toast.success(response.message || "Status updated!");

            triggerRefresh();
        } catch (error) {
            console.error("Toggle Error:", error);
            toast.error("Failed to update status");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                setLoading(true);
                const token = sessionStorage.getItem("sessionToken");
                const data = await getData('categories/categories', {}, token);
                console.log("API Full Response: ", data);
                const results = data?.data?.results?.[0]?.paginatedResults || [];
                setCategories(results);
            } catch (error) {
                console.error("Failed to load categories", error);
            } finally {
                setLoading(false);
            }
        };

        const fetchAttributes = async () => {
            try {
                setLoading(true);
                const token = sessionStorage.getItem("sessionToken");
                const data = await getData('attributes/attributes', {}, token);
                console.log("API Full Response: ", data);
                const results = data?.data?.results?.results || [];
                setAttributes(results);
            } catch (error) {
                console.error("Failed to fetch Attributes", error);
            } finally {
                setLoading(false);
            }
        }

        fetchCategories();
        fetchAttributes();
    }, []);

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#e6cf80',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    return (
    
        <div className="SubCategory-layout">
            {loading && <FullscreenLoader />}
            <div className="SubCategory-content">
                <main className="SubCategory-main">
                    {isAddPage ? (
                        <div className="add-category-form">
                            <h3>Add SubCategory</h3>

                            <form className="category-form">
                                <div className="category-form-row">

                                    {/* Subcategory Name */}
                                    <div className="category-form-group">
                                        <label className="input-label">
                                            Subcategory Name <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter subcategory name"
                                            className={`category-input ${errors.subCategoryName ? "input-error" : ""}`}
                                            onChange={(e) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    subCategoryName: e.target.value,
                                                }))
                                            }
                                        />
                                        {errors.subCategoryName && (
                                            <p className="error-msg">{errors.subCategoryName}</p>
                                        )}
                                    </div>

                                    {/* Category Dropdown */}
                                    <div className="category-form-group">
                                        <label className="input-label">
                                            Category <span className="required">*</span>
                                        </label>
                                        <select
                                            className={`category-input ${errors.categoryId ? "input-error" : ""}`}
                                            value={formData.categoryId || ""}
                                            onChange={(e) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    categoryId: e.target.value,
                                                }))
                                            }
                                        >
                                            <option value="">Select Category</option>
                                            {categories.map((cat) => (
                                                <option key={cat._id} value={cat._id}>
                                                    {cat.categoryName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.categoryId && <p className="error-msg">{errors.categoryId}</p>}
                                    </div>

                                    {/* Description */}
                                    <div className="category-form-group">
                                        <label className="input-label">Description</label>
                                        <input
                                            type="text"
                                            placeholder="Enter description"
                                            className="category-input"
                                            onChange={(e) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    description: e.target.value,
                                                }))
                                            }
                                        />
                                    </div>

                                    {/* Subcategory Image */}
                                    <div className="category-form-group">
                                        <label className="input-label">Subcategory Image</label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            className="category-input"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                setsubCategoryImage(file);
                                                setPreviewUrl(URL.createObjectURL(file));
                                            }}
                                        />

                                        {previewUrl && (
                                            <div className="image-preview">
                                                <img src={previewUrl} alt="Preview" />
                                            </div>
                                        )}
                                    </div>

                                    {/* 🔥 Attribute Multi-Select Section */}
                                    <div className="category-form-group full-width">
                                        <label className="input-label">
                                            Attributes <span className="required">*</span>
                                        </label>

                                        <Select
                                            key={formData.attributes?.join(",")}
                                            isMulti
                                            classNamePrefix="select"
                                            placeholder="Select attributes"

                                            /* Dropdown options */
                                            options={(attributes || []).map((attr) => ({
                                                value: attr._id.toString(),   // convert to string here
                                                label: attr.attributeName
                                            }))}

                                            /* Pre-selected values */
                                            value={(formData.attributes || []).map((id) => {
                                                const found = attributes.find(
                                                    (a) => a._id.toString() === id.toString()
                                                );
                                                return found
                                                    ? { value: found._id.toString(), label: found.attributeName }
                                                    : null;
                                            }).filter(Boolean)}

                                            /* ⭐ Convert ObjectIds → string HERE */
                                            onChange={(selected) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    attributes: selected
                                                        ? selected.map((s) => s.value.toString())  // convert here
                                                        : []
                                                }))
                                            }
                                        />

                                        {errors.attributes && (
                                            <p className="error-msg">{errors.attributes}</p>
                                        )}
                                    </div>

                                </div>

                                {/* Buttons */}
                                <div className="category-buttons">
                                    <button className="add-category-button" onClick={handleAddSubCategory}>
                                        Add SubCategory
                                    </button>
                                    <button
                                        className="cancel-category-button"
                                        onClick={() => navigate("/sub-category")}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>

                            <div className="SubCategory-widgets">
                                <div className="SubCategory-widgets-header">
                                    <h3>Sub Categories</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="subCategory-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <button className="add-btn-SubCategory"
                                    onClick={() => navigate('/sub-category/add')}
                                >+ Add SubCategory</button>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                overflow: 'outo',
                                maxHeight: '400px',
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none'
                            }}>
                                <Table className="custom-SubCategory-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-SubCategory-head">
                                        <TableRow >
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#e6cf80',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                            alignItems: 'center',
                                                            justifyContent: "left"
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {subcategories.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography sx={{ textAlign: 'center', padding: '20px', fontWeight: 500 }}>
                                                        No subCategories found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            subcategories.map((subcat, index) => (
                                                <TableRow key={subcat._id}>
                                                    <TableCell>
                                                        <Typography sx={{ justifyContent: 'center', alignItems: 'left' }}>{index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'left' }}>
                                                            <img
                                                                src={`${process.env.REACT_APP_API_URL}${subcat.subCategoryImageObject?.uri}` || "/assets/placeholder.png"}
                                                                alt={subcat.name}
                                                                style={{ width: 40, height: 40, borderRadius: '4px' }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{subcat.name || subcat.subCategoryName}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{subcat.categoryDetails?.[0]?.categoryName}</Typography>
                                                    </TableCell>
                                                    
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{subcat.subCategoryCode}</Typography>
                                                    </TableCell>
                                                    <TableCell >
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                                                            <Switch
                                                                checked={subcat.isActive}
                                                                onChange={(e) => handleToggle(subcat._id, e.target.checked)}   // send id + status
                                                                sx={{
                                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                                        color: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                        backgroundColor: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-track': {
                                                                        backgroundColor: '#C10000',
                                                                    },
                                                                }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell >
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                                                            <Switch
                                                                checked={subcat.isOnline}
                                                                onChange={(e) => handleToggleOnline(subcat._id, e.target.checked)}   // send id + status
                                                                sx={{
                                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                                        color: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                        backgroundColor: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-track': {
                                                                        backgroundColor: '#C10000',
                                                                    },
                                                                }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'left' }}>
                                                            <Icon icon={plusIcon} width={20} height={20} style={{ cursor: 'pointer' }} onClick={() => handleViewsubCategory(subcat._id)} />
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                setFormData({
                                                                    categoryId: subcat.categoryId || '',
                                                                    subCategoryName: subcat.subCategoryName || subcat.subCategoryName || '',
                                                                    description: subcat.description || '',
                                                                    storeId: subcat.storeId?._id || subcat.storeId || "",
                                                                    attributes: Array.isArray(subcat.attributes)
                                                                    ? subcat.attributes.map(a =>
                                                                        typeof a === "object" ? a._id.toString() : a.toString()
                                                                    )
                                                                    : [],
                                                                });
                                                                setPreviewUrl(
                                                                    subcat?.subCategoryImageObject?.uri
                                                                        ? `${process.env.REACT_APP_API_URL}${subcat.subCategoryImageObject.uri}`
                                                                        : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                                                );
                                                                setsubCategoryImage(null);
                                                                setEditsubCategoryId(subcat._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: 'pointer' }}
                                                                onClick={() => handleOpen(subcat._id)}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="product-bottom">
                                <div className="product-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="product-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="product-section spacer"></div>
                                <div className="product-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <div className="popup-form">
                                            <h2 className="popup-title">
                                                {isEditMode ? "Edit Category" : "Add Category"}
                                            </h2>
                                            <form className="popup-form-body" onSubmit={handleUpdateSubCategory}>
                                                <div className="form-group-row">

                                                    {/* Subcategory Name */}
                                                    <div className="form-group">
                                                        <label htmlFor="subCategoryName">
                                                            Subcategory Name <span className="required">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="subCategoryName"
                                                            className={`category-input ${errors.subCategoryName ? "input-error" : ""}`}
                                                            placeholder="Enter subcategory name"
                                                            value={formData.subCategoryName}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    subCategoryName: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                        {errors.subCategoryName && <p className="error-msg">{errors.subCategoryName}</p>}
                                                    </div>

                                                    {/* Category */}
                                                    <div className="form-group">
                                                        <label htmlFor="CategoryName">
                                                            Category <span className="required">*</span>
                                                        </label>
                                                        <select
                                                            id="subCategoryId"
                                                            className={`category-input ${errors.categoryId ? "input-error" : ""}`}
                                                            value={formData.categoryId}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    categoryId: e.target.value,
                                                                }))
                                                            }
                                                        >
                                                            <option value="">Select Category</option>
                                                            {categories.map((cat) => (
                                                                <option key={cat._id} value={cat._id}>
                                                                    {cat.categoryName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.categoryId && <p className="error-msg">{errors.categoryId}</p>}
                                                    </div>
                                                </div>

                                                <div className="form-group-row">

                                                    {/* Description */}
                                                    <div className="form-group">
                                                        <label htmlFor="description">Description</label>
                                                        <input
                                                            type="text"
                                                            id="description"
                                                            placeholder="Enter description"
                                                            value={formData.description}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    description: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                    </div>

                                                    {/* Image */}
                                                    <div className="form-group">
                                                        <label htmlFor="subcategoryImage">Subcategory Image</label>
                                                        <input
                                                            type="file"
                                                            id="subcategoryImage"
                                                            accept="image/*"
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                setsubCategoryImage(file);
                                                                setPreviewUrl(URL.createObjectURL(file));
                                                            }}
                                                        />
                                                        {previewUrl && (
                                                            <div className="image-preview">
                                                                <img src={previewUrl} alt="Preview" />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="subcategoryImage">Attributes<span className="required">*</span></label>
                                                        <Select
                                                            isMulti
                                                            classNamePrefix="select"
                                                            placeholder="Select attributes"

                                                            /* Dropdown options */
                                                            options={(attributes || []).map((attr) => ({
                                                                value: attr._id.toString(),
                                                                label: attr.attributeName
                                                            }))}

                                                            /* Pre-selected values */
                                                            value={
                                                                (formData.attributes || []).map((id) => {
                                                                    const found = attributes.find(a => a._id.toString() === id.toString());
                                                                    return found
                                                                        ? { value: found._id.toString(), label: found.attributeName }
                                                                        : null;
                                                                }).filter(Boolean)
                                                            }

                                                            /* Update on change */
                                                            onChange={(selected) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    attributes: selected ? selected.map((s) => s.value.toString()) : []
                                                                }))
                                                            }
                                                        />
                                                        {errors.attributes && <p className="error-msg">{errors.attributes}</p>}
                                                    </div>
                                                </div>
                                                
                                                {/* Buttons */}
                                                <div className="form-actions">
                                                    <button type="submit" className="btn-primary">
                                                        {isEditMode ? "Update SubCategory" : "Add SubCategory"}
                                                    </button>
                                                    <button type="button" className="btn-secondary" onClick={() => setIsPopupMode(false)}>
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && categories.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more  subCategories
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this subCategory?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: "#8D2629 " }} onClick={handleDeleteCategory}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                            {openViewPopup && (
                                <ViewsubCategoryPopup
                                    data={viewsubCategoryData}
                                    onClose={() => setOpenViewPopup(false)}
                                />
                            )}
                        </>
                    )}

                </main>
            </div>
        </div>

    );
};

export default SubCategoryPage;